export default "__VITE_ASSET__BtL2qtLG__"